import { createApp } from 'vue';
import App from './App.vue';
import { InitCommonLibs } from 'scriptsShared/Inits.js';

const app = createApp(App, {
    initialData: initialData
});

InitCommonLibs(app, initialData.locale);

app.mount('#app');